import { useState, useRef } from "react";

const Assistant = () => {
    const [response, setResponse] = useState("");
    const [isRecording, setIsRecording] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);

    const startRecording = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;
        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
                audioChunksRef.current.push(e.data);
            }
        };

        mediaRecorder.onstop = async () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
            const transcription = await transcribeAudio(audioBlob);

            if (!transcription) {
                setResponse("Je n'ai pas compris, pouvez-vous répéter ?");
                return;
            }

            const assistantReply = await getAssistantResponse(transcription);
            setResponse(assistantReply);

            const ttsAudio = await synthesizeSpeech(assistantReply);
            const audioURL = URL.createObjectURL(ttsAudio);
            const audio = new Audio(audioURL);
            setIsSpeaking(true);
            audio.play();
            audio.onended = () => {
                setIsSpeaking(false);
                setTimeout(() => {
                    startRecording(); // relance automatiquement
                }, 500);
            };
        };

        mediaRecorder.start();
        setIsRecording(true);
        setTimeout(() => {
            mediaRecorder.stop();
            setIsRecording(false);
        }, 5000);
    };

    const transcribeAudio = async (audioBlob) => {
        const formData = new FormData();
        formData.append("file", audioBlob, "audio.webm");
        formData.append("model", "whisper-1");

        const res = await fetch("https://api.openai.com/v1/audio/transcriptions", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_OPEN_AI_KEY}`,
            },
            body: formData,
        });

        const data = await res.json();
        return data.text;
    };

    const getAssistantResponse = async (transcription) => {
        try {
            console.log("Transcription envoyée:", transcription);
            const res = await fetch("https://novamedical-server.onrender.com/api/askassistant", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ question: transcription }), // ✅ correction ici
            });

            const data = await res.json();
            return data.message || "Aucune réponse.";
        } catch (err) {
            console.error("Erreur backend assistant:", err);
            return "Erreur côté serveur.";
        }
    };

    const synthesizeSpeech = async (text) => {
        const res = await fetch("https://api.openai.com/v1/audio/speech", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_OPEN_AI_KEY}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                model: "tts-1",
                voice: "echo",
                input: text,
            }),
        });

        const audioBlob = await res.blob();
        return new File([audioBlob], "audio.mp3", { type: "audio/mpeg" });
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-[#f2f5f7] text-center">
            <h1 className="text-2xl font-semibold mb-4">Assistant de formation</h1>
            <button
                onClick={startRecording}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                disabled={isRecording}
            >
                🎙️ {isRecording ? "Enregistrement..." : "Parler"}
            </button>

            {response && (
                <div className="mt-4 text-lg text-gray-700 w-full max-w-xl">
                    <p className="font-medium">Réponse : </p>
                    <p>{response}</p>
                </div>
            )}

            {isSpeaking && (
                <div className="mt-6">
                    <div className="w-24 h-24 rounded-full bg-blue-500 animate-pulse mx-auto shadow-lg" />
                    <p className="text-sm text-gray-500 mt-2">L'assistant parle...</p>
                </div>
            )}
        </div>
    );
};

export default Assistant;